import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicFormBuilderRoutingModule } from './dynamic-form-builder-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

// import { SharedModule } from '../shared/shared.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgOtpInputModule } from 'ng-otp-input';
import { DynamicFormBuilderComponent } from './components/dynamic-form-builder/dynamic-form-builder.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { FormInputComponent } from './components/input/input.component';
import { FormSelectComponent } from './components/select/select.component';
import { FormTextAreaComponent } from './components/text-area/text-area.component';
import { FormDatePickerComponent } from './components/datepicker/datepicker.component';
import { FormTimePickerComponent } from './components/timepicker/timepicker.component';
import { ValidationErrorsComponent } from './components/validation-errors/validation-errors.component';
import { RadioButtonComponent } from './components/radio-button/radio-button.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { CustomInputListComponent } from './components/custom-input-list/custom-input-list.component';
import { OptionListComponent } from './components/option-list/option-list.component';

import { ButtonComponent } from '../../components/button/button.component';
import { InfoIconComponent } from '../../components/info-icon/info-icon.component';
import { AlertModalComponent } from '../../components/alert-modal/alert-modal.component';
import { DynamicFormBuilderService } from './services/dynamic-form-module.service';
import { LocationInputComponent } from './components/location-input/location-input.component';
import { FormMultiSelectComponent } from './components/multi-select/multi-select.component';
import { FormFileUploadInputComponent } from './components/file-upload-input/file-upload-input.component';
import { BannerImageUploadComponent } from './components/banner-image/banner-image.component';
import { NgxImageCompressService } from 'ngx-image-compress';
import { MobileInputComponent } from './components/mobile-input/mobile-input.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { PhoneMaskDirective } from './directive/phone-mask.directive';
import { SsnMaskDirective } from './directive/ssn-mask.directive';
import { FormFileUploadInputV2Component } from './components/file-upload-input-v2/file-upload-input-v2.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { LabelComponent } from './components/label/label.component';
import { ProfileImageUploadComponent } from './components/profile-image/profile-image.component';
import { ImageCropperComponent } from '../shared/components/image-cropper/image-cropper.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DisclaimerMessageComponent } from './components/disclaimer-message/disclaimer-message.component';
import { CustomMultiSelectComponent } from './components/custom-mutliselect/custom-multiselect.component';
import { MobileBridgeFileInputDirective } from '@shared/directive/mobile-bridge-file-input.directive';
import { PasswordInputComponent } from '@components/password-input/password-input.component';
import { FormMapIframeComponent } from '@modules/dynamic-form-builder/components/form-map-iframe/form-map-iframe.component';
@NgModule({
  declarations: [
    DynamicFormBuilderComponent,
    FormMapIframeComponent,
    FormInputComponent,
    FormDatePickerComponent,
    FormTimePickerComponent,
    RadioButtonComponent,
    FileUploadComponent,
    FormMultiSelectComponent,
    LocationInputComponent,
    CustomInputListComponent,
    FormFileUploadInputComponent,
    FormFileUploadInputV2Component,
    BannerImageUploadComponent,
    ProfileImageUploadComponent,
    OptionListComponent
  ],
  imports: [
    PhoneMaskDirective,
    SsnMaskDirective,
    MobileInputComponent,
    CheckboxComponent,
    CommonModule,
    DynamicFormBuilderRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    FormSelectComponent,
    ValidationErrorsComponent,
    FormTextAreaComponent,
    NgMultiSelectDropDownModule,
    // SharedModule,
    CarouselModule,
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgOtpInputModule,
    NgxMaterialTimepickerModule,
    ButtonComponent,
    InfoIconComponent,
    AlertModalComponent,
    NgxIntlTelInputModule,
    NgCircleProgressModule.forRoot({}),
    ImageCropperComponent,
    ImageCropperModule,
    NgxIntlTelInputModule,
    LabelComponent,
    DisclaimerMessageComponent,
    CustomMultiSelectComponent,
    MobileBridgeFileInputDirective,
    PasswordInputComponent
  ],
  providers: [
    DynamicFormBuilderService,
    NgxImageCompressService,
    PhoneMaskDirective,
    SsnMaskDirective
  ],
  exports: [
    DynamicFormBuilderComponent,
    PhoneMaskDirective,
    SsnMaskDirective,
    MobileInputComponent,
    RadioButtonComponent,
    FileUploadComponent,
    ButtonComponent,
    AlertModalComponent,
    FormInputComponent,
    CheckboxComponent,
    CustomInputListComponent,
    LocationInputComponent,
    ValidationErrorsComponent,
    PhoneMaskDirective,
    SsnMaskDirective,
    FormSelectComponent,
    LabelComponent,
    FormTextAreaComponent,
    BannerImageUploadComponent,
    CustomMultiSelectComponent,
    OptionListComponent,
    MobileBridgeFileInputDirective,
    FormDatePickerComponent,
    FormMapIframeComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DynamicFormBuilderModule {}